export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14211.e037ad80.jpg";